import { reactive } from "vue";

export const formGrids = reactive({
  grids: new Map(),

  add(id, instance) {
    this.grids.set(id, instance);
  },
  remove(id) {
    this.grids.delete(id);
  },
  async saveAllEdits() {
    for (const [,grid] of this.grids) {
      if (grid.instance.hasEditData && grid.instance.hasEditData()) {
        await grid.instance.saveEditData();
      }
    }
  }
});